/**
 * Constants for ImageUpload component
 */

export const IMAGE_UPLOAD_CONSTANTS = {
  ACCEPTED_TYPES: {
    PREVIEW: 'image/png',
    UPLOAD: 'image/jpeg,image/png'
  },
  DIMENSIONS: {
    WIDTH: 392,
    HEIGHT: 188
  },
  MAX_SIZE: {
    VALUE: 500,
    UNIT: 'KB'
  },
  MESSAGES: {
    DRAG_DEFAULT: 'Arraste e solte, ou',
    DRAG_ACTIVE: 'Solte o arquivo aqui',
    SELECT_FILE: 'selecione o arquivo',
    CHANGE_IMAGE: 'Clique para alterar a imagem',
    SIZE_INFO: 'arquivo PNG (392×188) até 500 KB',
    REQUIRED_LABEL: 'Imagem:'
  },
  ALT_TEXT: 'Preview da imagem do evento',
  INPUT_IDS: {
    PREVIEW: 'imagem-upload-preview',
    UPLOAD: 'imagem-upload'
  }
}
